import { produce } from "immer";
import { ITableFilterState } from "../interfaces/table-filter.state";
import { TablesState } from "../interfaces/tables-state";

export const setFiltersHandler = function (state: TablesState, tableId: string, filters: ITableFilterState[]) {
  const nextState = produce(state[tableId], draft => {
    draft.filters = filters;
    // Changing the filter criteria (incl. filter sets) restarts pagination at the first page.
    draft.pagination.page = 0;
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const addFiltersHandler = function (state: TablesState, tableId: string, filters: ITableFilterState[]) {
  if (!filters) {
    return state;
  }

  const nextState = produce(state[tableId], draft => {
    // Add new filters
    draft.filters = [...filters,...draft.filters];
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const updateFilterHandler = function (state: TablesState, tableId: string, filter: ITableFilterState) {


  const nextState = produce(state[tableId], draft => {
    var updateFilter = draft.filters.find(f => f.fieldName == filter.fieldName && f.id == filter.id);
    if (updateFilter) {
      updateFilter.id = filter.id;
      updateFilter.operator = filter.operator;
      updateFilter.value = filter.value;
      updateFilter.apply = filter.apply;
    }

    // Set page to 0 when you change a filter  
    draft.pagination.page = 0;


  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const addOrUpdateFilterHandler = function (state: TablesState, tableId: string, filter: ITableFilterState) {

  var filterExists = state[tableId].filters.some(f => f.fieldName == filter.fieldName && f.id == filter.id);
  if (!filterExists)
    return addFiltersHandler(state, tableId, [filter]);

  const nextState = produce(state[tableId], draft => {
    var updateFilter = draft.filters.find(f => f.fieldName == filter.fieldName && f.id == filter.id);
    if (updateFilter) {
      updateFilter.id = filter.id;
      updateFilter.operator = filter.operator;
      updateFilter.value = filter.value;
      updateFilter.apply = filter.apply;
    }

    // Set page to 0 when you change a filter  
    draft.pagination.page = 0;
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const removeFilterHandler = function (state: TablesState, tableId: string, fieldName: string) {

  const nextState = produce(state[tableId], draft => {
    const index = draft.filters.findIndex(x => x.fieldName == fieldName)
    if (index !== -1) {
      draft.filters.splice(index, 1)
    }

    // Set page to 0 when you change a filter  
    draft.pagination.page = 0;
  })

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const removeAllFiltersFromFieldname = function (state: TablesState, tableId: string, fieldName: string) {

  let oldstate = { ...state[tableId] };

  const nextState = produce(oldstate, draft => {

    // Find all indices of items with the specified FieldName
    const indicesToRemove: number[] = draft.filters.reduce<number[]>((acc, current, index) => {
      if (current.fieldName === fieldName) {
        acc.push(index);
      }
      return acc;
    }, []);

    // Remove items with the specified FieldName
    for (let i = indicesToRemove.length - 1; i >= 0; i--) {
      const index = indicesToRemove[i];
      draft.filters.splice(index, 1);

    }
    // Set page to 0 when you change a filter
    draft.pagination.page = 0;
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}

export const removeAllFiltersHandler = function (state: TablesState, tableId: string) {

  const nextState = produce(state[tableId], draft => {
    draft.filters = [];
    // Clearing filters restarts pagination at the first page.
    draft.pagination.page = 0;
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}
export const removeAllFiltersFromInstallationHandler = function (state: TablesState) {

  // TODO: This works, but the usersession only updates for one page. 
  // So otherpages will still have filters
  const updatedState: TablesState = {}

  for (const tableId in state) {
    updatedState[tableId] = {
      ...state[tableId],
      filters: []
    }
  }

  return updatedState
}

export const removeAllUnappliedFiltersHandler = function (state: TablesState, tableId: string) {


  const nextState = produce(state[tableId], draft => {
    draft.filters = draft.filters.filter(f => f.apply);

    // Set page to 0 when you remove a filter
    draft.pagination.page = 0;
  });

  return {
    ...state,
    [tableId]: { ...nextState }
  }
}
